import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">DREAM<span>DRUMS</span></div>
            <p className="footer-tagline">{t('footer_tagline')}</p>
          </div>

          <div className="footer-columns">
            <div className="footer-col">
              <h4>{t('footer_contact')}</h4>
              <p>{t('representative')}: {t('representative_name')}</p>
              <p>{t('phone_number')}</p>
              <p>{t('footer_email')}</p>
              <p>{t('address')}</p>
            </div>

            <div className="footer-col">
              <h4>{t('footer_terms')}</h4>
              <Link to="/privacy-policy">{t('privacy_policy')}</Link>
              <Link to="/terms-of-service">{t('terms_of_service')}</Link>
            </div>

            <div className="footer-col">
              <h4>{t('social_media')}</h4>
              <a href="https://www.instagram.com/_dreamdrums/" target="_blank" rel="noopener noreferrer">{t('instagram')}</a>
              <a href="https://blog.naver.com/dreamdrums" target="_blank" rel="noopener noreferrer">{t('naver_blog')}</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>{t('copyright')}. All rights reserved.</span>
          <span>{t('business_number')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
